import { SET_ALERT_MESSAGE, CLEAR_ALERT_MESSAGE } from "../actionTypes";

export const showAlertPopup = (alertHeader,alertMessage) => ({
  type: SET_ALERT_MESSAGE,
  payload: {alertHeader,alertMessage},
});

export const clearAlertPopup = () => ({
  type: CLEAR_ALERT_MESSAGE,
});